const React = require('react');
const PropTypes = require('prop-types');
require('./LegendEntries.scss');


const LegendEntries = props => (
    <div className="legend-entries">
        {
            props.payload.map((entry, i) => (
                <span className="legend-entries__entry" key={i}>
                    <i className={props.iconClass} style={{ color: entry.color }} />
                    &nbsp;
                    {entry.value}
                </span>
            ))
        }
    </div>
);


LegendEntries.defaultProps = {
    iconClass: 'icon-radio-check',
    payload: [],
};

LegendEntries.propTypes = {
    iconClass: PropTypes.string,
    payload: PropTypes.array.isRequired,
};


module.exports = LegendEntries;
